import * as React from 'react';
import { Form } from 'antd';
import { FormComponentProps, WrappedFormUtils, ValidationRule } from 'antd/lib/form/Form';
import bindAllOfThis from "src/utils/BindThisHelper";
import { Translate, withLocalize, LocalizeContextProps } from 'react-localize-redux';

interface GenericFormItemProps extends LocalizeContextProps {
    // Required
    form: WrappedFormUtils;
    /** This ID is used to define this field in its given form. Ensure it is unique */
    id: string;

    /** The translationID for the label */
    labelId?: string;
    initialValue?: any;
    visible?: boolean;
    required?: boolean;

    rules?: ValidationRule[];
}

class GenericFormItemInternal extends React.Component<GenericFormItemProps> {
    constructor(props) {
        super(props);
        bindAllOfThis(this, GenericFormItemInternal.prototype);
    }

    render() {
        let rules = [];
        let translatedLabel: string;
        let children: any = this.props.children;
        if (this.props.visible != null && this.props.visible === false) {
            return null;
        }

        // Debugging and catch statements
        if (this.props.form == null) {
            console.warn("Form is null. Please pass in the antd form");
            return null;
        }
        if (Array.isArray(children)) {
            console.warn("Form Item children must be a single react component, not an array. Rendering first element");
            children = children[0];
        }

        // Rules
        if (this.props.required == null || this.props.required === true) {
            rules.push({ required: true, message: this.props.translate('admin.common.requiredRule') });
        }

        if (this.props.rules != null && this.props.rules.length > 0) {
            rules = [...rules, ...this.props.rules];
        }

        // Translations
        if (this.props.labelId != null && this.props.labelId.length > 0) {
            translatedLabel = this.props.translate(this.props.labelId).toString();
        }

        // Create our fancy field decorator function
        let fieldDecorator = this.props.form.getFieldDecorator(this.props.id, {
            initialValue: this.props.initialValue,
            rules: rules
        });

        return <Form.Item label={translatedLabel}>
            {fieldDecorator(children)}
        </Form.Item>;
    }
}

/**
 * Obsolete: Please use the `FieldDecorator` component instead. It is located in the `components/common/form` folder
 */
let GenericFormItem = withLocalize<GenericFormItemProps>(GenericFormItemInternal);

export { GenericFormItem };



// WEBPACK FOOTER //
// ./src/utils/FormUtil.tsx